import { GENERATION_TOOL } from 'src/data/generationTool';
import { PROJECT_TYPE } from 'src/data/project';

import { TEMPLATE_TAG } from './tags';

const GENERIC_TEMPLATES = [
  // Blog
  {
    projectType: PROJECT_TYPE.blogPostBuilder,
    generationTool: GENERATION_TOOL.blogDescription,
    tags: [
      TEMPLATE_TAG.channelBlog,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.articleBlogHeadline,
    tags: [
      TEMPLATE_TAG.channelBlog,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.basicBlogIdeas,
    tags: [
      TEMPLATE_TAG.channelBlog,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },

  // Ads
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.facebookMixtureAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bAbm,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.googleRSA,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.googleHeadlineProduct,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.googleDescriptionProduct,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.googlePerformanceMaxAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.linkedinMixtureAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bAbm,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.twitterMixtureAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bAbm,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.outbrainHeadlineProduct,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.taboolaHeadlineProduct,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.pinterestMixtureAd,
    tags: [
      TEMPLATE_TAG.channelAds,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  // TODO: Acquisition Ad Campaign	Ads	Ads	Live	DD multi-prompt template

  // Website
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingPageProductAnnouncementMultiPrompt,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bProductMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingHeadline,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingSubheader,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingCTA,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingBenefits,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingFeatures,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.landingSEOMetadata,
    tags: [
      TEMPLATE_TAG.channelWebsite,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  // TODO: Case Study - B2B	Website	Website	Live	DD multi-prompt template
  // TODO: Landing Page - SaaS (Lead Generation)	Website	Website	Live	DD multi-prompt template

  // Social
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.instagramCaption,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.facebookPost,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.tweet,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.linkedinPost,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.pinterestPostDescription,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.pinterestPostTitle,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.youtubeDescription,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.youtubeTitle,
    tags: [
      TEMPLATE_TAG.channelSocial,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  // TODO: Repurpose Blog Content	Social	Social	Live	DD multi-prompt template

  // Email
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.emailDripMultiPrompt,
    tags: [
      TEMPLATE_TAG.channelEmail,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.emailMixture,
    tags: [
      TEMPLATE_TAG.channelEmail,
      TEMPLATE_TAG.b2bAbm,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.emailSubject,
    tags: [
      TEMPLATE_TAG.channelEmail,
      TEMPLATE_TAG.b2bAbm,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cLifecycleRetention,
    ],
  },
  // TODO: Newsletter	Email	Email	Live	DD multi-prompt template

  // Ecommerce
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.amazonProductListing,
    tags: [
      TEMPLATE_TAG.channelOther,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.walmartProductListing,
    tags: [
      TEMPLATE_TAG.channelOther,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.generalProductListing,
    tags: [
      TEMPLATE_TAG.channelOther,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.basicProductReview,
    tags: [
      TEMPLATE_TAG.channelOther,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.basicPerfectHeadline,
    tags: [
      TEMPLATE_TAG.channelOther,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
      TEMPLATE_TAG.b2cEcommerceWebsiteOptimization,
    ],
  },
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.smsPromotional,
    tags: [
      TEMPLATE_TAG.channelOther,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },

  // General writing
  // TODO: AIDA	General Writing	-	Live	DD prompt template
  // TODO: PAS	General Writing	-	Live	DD prompt template
  // TODO: Explain it to a 5th Grader	General Writing	-	Live	DD prompt template
  // TODO: Sentence Expander	General Writing	-	Live	DD prompt template
  // TODO: Talking Points to Paragraph	General Writing	-	Live	DD prompt template
  // TODO: Summarizer	General Writing	-	Live	DD prompt template

  // Images
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.imageWithDescription,
    tags: [
      TEMPLATE_TAG.channelImages,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bProductMarketing,
      TEMPLATE_TAG.b2bContentMarketing,
      TEMPLATE_TAG.b2bFieldMarketing,
      TEMPLATE_TAG.b2bBrandCommunications,
      TEMPLATE_TAG.b2cPerformance,
      TEMPLATE_TAG.b2cBrandCreative,
      TEMPLATE_TAG.b2cContentSocial,
      TEMPLATE_TAG.b2cLifecycleRetention,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },

  // Other
  {
    projectType: PROJECT_TYPE.document,
    generationTool: GENERATION_TOOL.productLaunchMultiPrompt,
    tags: [
      TEMPLATE_TAG.channelOther,
      TEMPLATE_TAG.b2bDemandGeneration,
      TEMPLATE_TAG.b2bProductMarketing,
      TEMPLATE_TAG.b2cProductMarketing,
    ],
  },
];

export const getAllGenericTemplates = () => GENERIC_TEMPLATES;

export const getGenericTemplatesForTag = (tag) => {
  return GENERIC_TEMPLATES.filter((template) => template.tags.includes(tag));
};
